import { render } from "./CustomSource.vue?vue&type=template&id=71e1e505&scoped=true"
import script from "./CustomSource.vue?vue&type=script&lang=js"
export * from "./CustomSource.vue?vue&type=script&lang=js"

import "./CustomSource.vue?vue&type=style&index=0&id=71e1e505&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e1e505"]])

export default __exports__